import "../img/learning-providers/learning-providers-banner.png";
import "../img/learning-providers/offer-1.jpg";
import "../img/learning-providers/offer-2.jpg";
